import React, { useEffect } from 'react';
import { styled } from '@mui/material/styles';
import List from '@mui/material/List';
import ListSubheader from '@mui/material/ListSubheader';
import PropertyIcon from '../../../images/Property-Holders-white.svg';
import routes from '../../../constants/Routes';
import theme, { Theme } from 'theme';
import SidebarNavItems from './SidebarNavItems';
import { ReactComponent as CampaignIcon } from '../../../images/sidebar/Campaign.svg';
import { ReactComponent as DeviceLocationsIcon } from '../../../images/sidebar/Device-Locations.svg';
import { ReactComponent as DashboardIcon } from '../../../images/sidebar/Dashboard.svg';
import { ReactComponent as AdvertisementsIcon } from '../../../images/sidebar/Advertisements.svg';
import { ReactComponent as ContentLibraryIcon } from '../../../images/sidebar/Content-Library.svg';
import { ReactComponent as ScreenShotIcon } from '../../../images/sidebar/Screen-Shot.svg';
import { ReactComponent as LayoutIcon } from '../../../images/sidebar/Layouts.svg';
import { ReactComponent as RefundIcon } from '../../../images/sidebar/Refund.svg';
import { ReactComponent as FeedBackIcon } from '../../../images/sidebar/Property-Holder.svg';
import { useAppDispatch } from 'Stores/Hooks/hooks';
import { SIDEBAR_COLLAPSED } from 'Stores/Slices/clientReportsSlice';

const PREFIX = 'SidebarNav';

const classes = {
    navList: `${PREFIX}-navList`,
    navListHeader: `${PREFIX}-navListHeader`,
    iconFeatures: `${PREFIX}-iconFeatures`,
    iconDocs: `${PREFIX}-iconDocs`,
    iconSupporters: `${PREFIX}-iconSupporters`,
    iconDiscuss: `${PREFIX}-iconDiscuss`
};

const Root = styled('div')((
    {
        theme: Theme
    }
) => ({
    [`& .${classes.navList}`]: {
        width: theme.sidebar.width,
        fontSize: '1.1em',
        fontWeight: 400,
        lineHeight: 1.5,
        letterSpacing: '0.00938em',
    },

    [`& .${classes.navListHeader}`]: {
        textAlign: 'center',
    },

    [`& .${classes.iconFeatures}`]: {
        color: '#95de3c',
    },

    [`& .${classes.iconDocs}`]: {
        color: '#f8cda9',
    },

    [`& .${classes.iconSupporters}`]: {
        color: '#e3b546',
    },

    [`& .${classes.iconDiscuss}`]: {
        color: '#ccc',
    }
}));

export interface SidebarNavProps {
	isCollapsed: boolean;
}

const SidebarNav = (props: SidebarNavProps) => {
	const { isCollapsed } = props;

  const dispatch = useAppDispatch();

  dispatch(SIDEBAR_COLLAPSED(isCollapsed));


	const PropertyIconImg = () => {
		return <img alt="icon property" src={PropertyIcon}></img>;
	};


	const itemsCoreModules = [
		{
			name: 'Dashboard',
			link: routes.DASHBOARD.path,
			Icon: DashboardIcon,
		},
		{
			name: 'Reports',
			link: routes.REPORTS.path,
			Icon: DeviceLocationsIcon,
		},
		{
			name: 'Advertisements',
			link: routes.ADVERTISEMENT_DETAILS.path,
			Icon: AdvertisementsIcon,
		},
		{
			name: 'Campaign',
			link: routes.CAMPAIGN.path,
			Icon: CampaignIcon,
		},
		{
			name: 'Content Library',
			link: routes.CONTENT_LIBRARY.path,
			Icon: ContentLibraryIcon,
		},
		{
			name: 'Screenshot',
			link: routes.SCREEN_SHOT.path,
			Icon: ScreenShotIcon,
		},
		{
			name: 'Layouts',
			link: routes.TEMPLATE_LIST.path,
			Icon: LayoutIcon,
		},
		{
			name: 'Refund',
			link: routes.REFUND.path,
			Icon: RefundIcon,
		},
		{
			name: 'Feedback',
			link: routes.FEEDBACK.path,
			Icon: FeedBackIcon,
		},
	];

	return (
        <Root>
			<List className={classes.navList} disablePadding>
				{!isCollapsed && (
					<ListSubheader
						disableSticky={true}
						className={classes.navListHeader}
					/>
				)}
				<SidebarNavItems isCollapsed={isCollapsed} items={itemsCoreModules} />
			</List>
		</Root>
    );
};

export default SidebarNav;
